<template>
  <b-card
    no-body
    class="mb-2"
  >
    <b-card-header class="p-2">
      <b-card-title class="font-medium-2 card-title">
        <feather-icon
          icon="MapPinIcon"
          size="18"
        />
        <span class="align-middle ml-50">
          Destinatário
        </span>
      </b-card-title>
    </b-card-header>
    <hr class="my-0">
    <div class="p-2">

      <b-row>
        <b-col
          cols="12"
          md="4"
        >
          <validation-provider
            #default="validationContext"
            name="Nome"
            rules="required|max:80"
          >
            <b-form-group
              label="Nome *"
              label-for="destinatario-nome"
            >
              <vue-autosuggest
                :value="destinatario.nome"
                :suggestions="suggestions"
                :input-props="inputProps"
                :get-suggestion-value="getSuggestionValue"
                @selected="onSelected"
                @input="onInputChange"
              >
                <template slot-scope="{suggestion}">
                  <div class="d-flex align-items-center">
                    <div class="detail ml-50">
                      <b-card-text class="mb-0">
                        {{ suggestion.item.nome }}
                      </b-card-text>
                      <small class="text-muted">
                        {{
                          suggestion.item.cidade + ' - ' +
                            suggestion.item.logradouro + ' - ' +
                            suggestion.item.numero
                        }}
                      </small>
                    </div>
                  </div>
                </template>
              </vue-autosuggest>
              <span class="undermessage-error">
                {{ validationContext.errors[0] }}
              </span>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <validation-provider
            v-slot="validationContext"
            name="Tipo de Documento"
            rules="required"
          >
            <b-form-group
              label="Tipo de Documento *"
              label-for="tipoDocumento"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="destinatario.tipoDocumento"
                :reduce="val=>val.value"
                :options="tipoDocumentoOptions"
                :clearable="false"
              />

              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <validation-provider
            v-slot="validationContext"
            name="Número do Documento"
            rules="required"
          >
            <b-form-group
              label="Número do Documento *"
              label-for="numeroDocumento"
              :state="getValidationState(validationContext)"
            >
              <b-form-input
                id="numeroDocumento"
                :key="cleaveKey"
                v-model="destinatario.numeroDocumento"
                v-cleave="destinatario.tipoDocumento ? cleaveOptions[destinatario.tipoDocumento.toLowerCase()] : 
                  cleaveOptions.cpf"
                :state="getValidationState(validationContext)"
                trim
                placeholder="000.000.000-00 ou 00.000.000/0000-00"
              />

              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <validation-provider
            #default="validationContext"
            name="Email"
            rules="email|max:100"
          >
            <b-form-group
              label="Email"
              label-for="destinatario-email"
            >
              <b-form-input
                id="destinatario-email"
                v-model="destinatario.email"
                :state="getValidationState(validationContext)"
                trim
                placeholder="destinatario@exemplo.com"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <validation-provider
            #default="validationContext"
            name="Celular"
            rules="phone"
          >
            <b-form-group
              label="Celular"
              label-for="destinatario-celular"
            >
              <b-form-input
                id="destinatario-celular"
                v-model="destinatario.celular"
                v-cleave="cleaveOptions.phone"
                :state="getValidationState(validationContext)"
                trim
                placeholder="(11) 00000-0000"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <validation-provider
            #default="validationContext"
            name="CEP"
            rules="required"
          >
            <b-form-group
              label="CEP *"
              label-for="destinatario-cep"
            >
              <b-form-input
                id="destinatario-cep"
                v-model="destinatario.cep"
                v-cleave="cleaveOptions.cep"
                :state="getValidationState(validationContext)"
                trim
                placeholder="00000-000"
                @blur="buscaEndereco"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <validation-provider
            #default="validationContext"
            name="Logradouro"
            rules="required|max:80"
          >
            <b-form-group
              label="Logradouro *"
              label-for="destinatario-logradouro"
            >
              <b-form-input
                id="destinatario-logradouro"
                v-model="destinatario.logradouro"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Av. Brasil"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col
          cols="12"
          md="2"
        >
          <validation-provider
            #default="validationContext"
            name="Numero"
            rules="required"
          >
            <b-form-group
              label="Número *"
              label-for="destinatario-numero"
            >
              <b-form-input
                id="destinatario-numero"
                v-model="destinatario.numero"
                :state="getValidationState(validationContext)"
                trim
                placeholder="110"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <validation-provider
            #default="validationContext"
            name="Complemento"
            rules="max:50"
          >
            <b-form-group
              label="Complemento"
              label-for="destinatario-complemento"
            >
              <b-form-input
                id="destinatario-complemento"
                v-model="destinatario.complemento"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Sala 220"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <validation-provider
            #default="validationContext"
            name="Bairro"
            rules="required|max:40"
          >
            <b-form-group
              label="Bairro *"
              label-for="destinatario-bairro"
            >
              <b-form-input
                id="destinatario-bairro"
                v-model="destinatario.bairro"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Centro"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <validation-provider
            #default="validationContext"
            name="Cidade"
            rules="required|max:40"
          >
            <b-form-group
              label="Cidade *"
              label-for="destinatario-cidade"
            >
              <b-form-input
                id="destinatario-cidade"
                v-model="destinatario.cidade"
                :state="getValidationState(validationContext)"
                trim
                placeholder="São Paulo"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <validation-provider
            #default="validationContext"
            name="UF"
            rules="required|max:2|min:2|noNumber"
          >
            <b-form-group
              label="UF *"
              label-for="destinatario-uf"
            >
              <b-form-input
                id="destinatario-uf"
                v-model="destinatario.uf"
                :state="getValidationState(validationContext)"
                :formatter="formatter"
                placeholder="SP"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
    </div>
    <hr class="my-0">
    <div class="p-2">

      <b-row class="flex-row-reverse">
        <div
          style="display:flex; align-items: center; justify-content: center"
        >
          <b-button
            variant="primary"
            class="mb-sm-0 mr-0 mr-sm-1"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            type="submit"
          >
            Próximo
            <feather-icon
              icon="ArrowRightIcon"
            />
          </b-button>
        </div>
        <div
          style="display:flex; align-items: center; justify-content: center"
        >
          <b-form-checkbox
            v-model="destinatario.salvar"
            switch
            class="mr-2"
          >
            Lembrar deste destinatário
          </b-form-checkbox>
        </div>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import cleaveOptions from '@/libs/cleave/options'
import { ref, watch, reactive, toRefs } from '@vue/composition-api'
import CepService from '@/service/CepService'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import { mapGetters } from 'vuex'

export default {
  name: 'Destinatario',
  props: {
    getValidationState: {
      type: Function,
      required: true,
    },
    destinatario: {
      type: undefined,
      required: true,
    },
  },
  data: () => ({
    inputProps: {
      id: 'autosuggest__input',
      class: 'form-control',
      placeholder: 'Digite o nome do destinatário',
    },
  }),

  computed: {
    ...mapGetters({
      firebaseUser: 'firebase/firebaseUser',
    }),
  },

  watch: {
    firebaseUser() {
      const { clienteId } = JSON.parse(localStorage.getItem('userName'))
      this.$store.dispatch('destinatario/findAll', clienteId)
    },
  },

  beforeMount() {
    const { clienteId } = JSON.parse(localStorage.getItem('userName'))
    this.$store.dispatch('destinatario/findAll', clienteId)
  },
  setup(props, { emit }) {
    const destinatarioStore = createNamespacedHelpers('destinatario')

    const state = reactive({
      destinatarioOptions: destinatarioStore.useGetters(['destinatarios']).destinatarios,
    })

    const cleaveKey = ref(0)

    const tipoDocumentoOptions = [
      { label: 'CPF', value: 'CPF' },
      { label: 'CNPJ', value: 'CNPJ' },
    ]

    const suggestions = ref([{ data: [] }])

    function incrementCleaveKey() {
      cleaveKey.value += 1
    }

    watch(() => props.destinatario.tipoDocumento, () => {
      incrementCleaveKey()
    })

    const reduce = value => {
      emit('update:destinatario', value)
    }

    const onSelected = option => {
      if (option.item.nome === props.destinatario.nome) {
        return
      }
      reduce(option.item)
    }

    const buscaEndereco = event => {
      CepService.buscarEndereco(event.target.value).then(endereco => {
        if (endereco) {
          if (endereco.success) {
            const dadosEndereco = JSON.parse(endereco.body)
            dadosEndereco.cep = event.target.value
            delete dadosEndereco.nome
            reduce({ ...props.destinatario, ...dadosEndereco })
          }
        }
      })
    }

    const onInputChange = text => {
      if (text.length >= 3) {
        const newDestinatario = { ...props.destinatario, nome: text }
        emit('update:destinatario', newDestinatario)
        const suggestionsArray = state.destinatarioOptions.filter(destinatario => destinatario.nome.toLowerCase().indexOf(text.toLowerCase())
          >= 0)
        suggestions.value = [{ data: suggestionsArray }]
      }
    }

    const getSuggestionValue = value => {
      const newDestinatario = { ...props.destinatario, ...value.item }
      emit('update:destinatario', newDestinatario)
      return value.item.nome
    }
    const formatter = value => value.toUpperCase()

    return {
      ...toRefs(state),
      cleaveOptions,
      tipoDocumentoOptions,
      cleaveKey,
      reduce,
      formatter,
      onInputChange,
      buscaEndereco,
      onSelected,
      getSuggestionValue,
      suggestions,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-autosuggest.scss';
</style>